import PropTypes from "prop-types";
import { TextWrapperSpan } from "../../constants/common/StyledGlobalConstants";

const UrlRedirection = ({ label, link, ariaLabel = label }) => {
 const handleClick = () => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleClick();
    }
  };
  
  return (
    <TextWrapperSpan
      tabIndex="0"
      aria-label={ariaLabel}
      role="link"
      color="#0077B4"
      fontSize="0.875rem"
      fontWeight="400"
      lineHeight="1.25rem"
      textDecorationLine="underline"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      style={{ cursor: "pointer" }}
    >
      {label}
    </TextWrapperSpan>
  );
};

UrlRedirection.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
};

export default UrlRedirection;
